// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__hsrSn","pulse":"styles_pulse__qJFAv","jump":"styles_jump__aIozH"};